import { render } from "./completedDialog.vue?vue&type=template&id=10605936&scoped=true"
import script from "./completedDialog.vue?vue&type=script&lang=js"
export * from "./completedDialog.vue?vue&type=script&lang=js"

import "./completedDialog.vue?vue&type=style&index=0&id=10605936&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10605936"]])

export default __exports__